import { Component, OnInit } from '@angular/core';
import { IPagamento } from '../interfaces/IPagamento';
import { DynamicDialogConfig } from 'primeng/api';
import * as Moment from 'moment'
import { AlertUtil } from '../utils/alert-util';
import { PaymentService } from '../services/payment.service';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';

@Component({
  selector: 'app-esecutore-pagamenti-modal',
  templateUrl: './esecutore-pagamenti-modal.component.html',
  styleUrls: ['./esecutore-pagamenti-modal.component.css']
})
export class EsecutorePagamentiModalComponent implements OnInit {
  listPagamentiEsecutore: IPagamento[]        //pagamento of esecutore selected in table

  constructor(private config: DynamicDialogConfig, private alertUtil: AlertUtil, private paymentSrervice: PaymentService) {
    this.listPagamentiEsecutore = this.config.data.listPagamenti
  }

  ngOnInit() {
  }

  /**
   * format date for html
   * @param date string from service
   */
  formatDateForChart(date: any): string {
    // format date value
    let valueMoment = Moment(date, "YYYY-MM-DDTHH:mm:ssZ", true)
    if (valueMoment.isValid()) {
      date = valueMoment.format("DD/MM/YYYY")
    }
    return date
  }

  /**
   * callback fired when Payment delete button is clicked
   * @param payment 
   */
  onDeletePaymentClick(payment: IPagamento) {
    this.alertUtil.showConfirmationAlert("LBL_DELETE_ESECUTORE_PAYMENT_CONFIRM", null, null, null, null, () => {
      this.deletePayment(payment)
    })
  }

  /**
   * call WS to delete Payment
   * @param paymentToDelete 
   */
  deletePayment(paymentToDelete: IPagamento) {
    let reqBuilder = new RequestBuilder({ Id: paymentToDelete.Id })
    this.paymentSrervice.delete(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.data) {
          //remove Payment deleted if response OK
          this.alertUtil.showAlert('LBL_DELETE_PAYMENT', null, null, null, () => {
            this.listPagamentiEsecutore.forEach((payment, index) => {
              if (payment.Id == paymentToDelete.Id) {
                this.listPagamentiEsecutore.splice(index, 1)
              }
            })
          })
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

}
